import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";

import post_logo from "../assets/spcs_logo.svg"

import VideoSection from "../sections/VideoSection";
//import Sponsors from "../components/Sponsors";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import video_image from "../assets/renaissance.jpg"
import tenable_logo from "../assets/sponsors/tenable-logo.png";
import vectra_logo from "../assets/sponsors/vectra-logo.png";
import airlock_logo from "../assets/sponsors/airlock-logo.png";
import ywh_logo from "../assets/sponsors/YWH_logo.png"
import harfanglab_logo from "../assets/sponsors/harfanglab.png"
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";

//import c2sec_logo from "../assets/sponsors/c2sec-logo.png";
//import cribl_logo from "../assets/sponsors/cribl-logo.png";
//import karspersky_logo from "../assets/sponsors/karsperky-logo.png";
//import splunk_logo from "../assets/sponsors/splunk.png";
//import menlo_logo from "../assets/sponsors/menlo-security-logo.png";
//import one_identity_logo from "../assets/sponsors/one-identity.png";
import ImageCarousel from "../components/ImageCarousel";
//import microsoft_logo from "../assets/microsoft_logo.png";
//import knowbe4_logo from "../assets/sponsors/knowbe4.png";

import PlanningSection from "../sections/PlanningSection";
import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";

import speaker_sander_hofman from "../assets/speakers/Hofman_Sander.jpg";
import speaker_bob_lord from "../assets/speakers/Lord headshot low res.jpg";
import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_emmanuel_schmid from "../assets/speakers/Schmid_Emmanuel.jpg";
import speaker_antony_ancelin from "../assets/speakers/Ancelin_Antony.jpg";


import SpeakerSection from "../sections/SpeakerSection";
import Sponsors from "../components/Sponsors";
/*
import hkta_logo from "../assets/hkta_logo.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import infomaniak from "../assets/infomaniak.png";

import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";
import speaker_daniel_kuenzli from "../assets/speakers/daniel-kuenzli.png";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
*/
import speaker_unknown from "../assets/speakers/unknown_person.jpg";

const eventDate: Date = new Date(2026, 5, 2, 12, 45); // 2 june 2026

export default function ZurichEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Limmat’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>A keynote presentation with inspiring insights from the perspective of a well-known CISO, exciting input presentations, and good networking opportunities await you. Aimed at Cybersecurity Experts, IT enthusiasts and Students with a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Renaissance Tower" url="https://maps.app.goo.gl/paA3bzXpQ6merQFH8" />
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          href="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594592/"
          newTab={false}
          style={{ maxWidth: "161px" }}
        >
          Register
        </ButtonLink>
      </section>
      
      {/*
      <section>
        <AboutTheEvent mapUrl="./limmathack-map.png" />
      </section>
      */}
      {/*
      <section>
      <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {
      <section>
        <Agenda
          headers={['', '']}
          agenda={[
            { time: "12:45 - 13:15", description1: "Registration and Welcome Coffee" },
            { time: "13:15 - 13:45", description1: "Opening Ceremony" },
            { time: "13:45 - 14:15", description1: "Hacklore and Secure by Design: How Stories Affect Our Safety [Bob Lord, former CISO of Yahoo and Founder of Hacklore.org]" },
            { time: "14:15 - 14:45", description1: "Threat Landscape Report" },
            { time: "14:45 - 15:15", description1: "Presentation from Main Sponsor Harfanglab" },
            { time: "15:15 - 15:40", description1: "Networking Break" },
            { time: "15:40 - 17:30", description1: "<b>Technical Presentations</b><ul><li>From Detection to Crisis Management: A real SOC & CSIRT story<br>[Antony Ancelin, Technical lead incident response and Greg Divorne, Director of CSIRT, Swiss Post Cybersecurity]</li><li>Every public OT breach is a free lesson: Are you taking notes?<br>[Emmanuel Schmid, Senior Security Engineer, Swiss Post Cybersecurity]</li><li>What Happens When the Attacker's AI Works Harder Than Your Entire SOC?<br>[Sven Kirchmayer, Senior Solution Architect, Elastic]</li><li>Presentation from [Tenable]</li>" },
            { time: "17:30", description1: "Apero and Networking" },
            { time: "18:00 - 20:00", description1: "CTF with Vetra AI; Detecting Hybrid Attacks with Respond UX" },
          ]
          }
        ></Agenda>
      </section>
      }
      {
      <section>
      <PlanningSection
          title=""
          subtitle=""
          displayGrid=""
          planning={[
            {
              time: "18:00 - 20:00",
              title: "Detecting Hybrid Attacks with Respond UX",
              description: "Join this 90-minute hands-on Blue Team challenge and discover how hybrid attacks can be detected across network and cloud environments using Vectra AI. Designed for beginner to intermediate participants, this session introduces the fundamentals of the Vectra platform and Respond UX, with a focus on alert triage, investigation workflows, and practical threat detection skills in a realistic SOC-style scenario. Trophies will be awarded to the top 3 teams.",
              index: 0,
              registerBtnText: 'Register now',
              registerUrl: 'https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594589/',
              logo: vectra_logo
            }
          ]}
        />
      </section>
      }
      {/*
      <section>
        {
        <PlanningSection
        title="Details"
        subtitle=""
        displayGrid="grid"
        planning={[
          {
            time: "13:00",
            title: "",
            description: "<h1>Registration & Welcome coffee</h1>",
            index: 0,
          },
          {
            time: "",
            title: "Network meets Identity: Modern detection and response for the hybrid world<br><small>Vectra - Fabian Gentinetta / Christian Borst</small>",
            description: "The modern network has changed. We went remote, and into the cloud. The cloud grew, and became more complex. Today, Active Directory and Entra ID stand at the core of most networks. IT and OT are converging, into one giant attack surface. In this talk, we offer strategic perspectives on how to navigate and secure this new reality.",
            index: 1,
          },
          {
            time: "",
            title: "Post Login: Stopping Lateral Movement with Privileged Access Analytics<br><small>Vectra - Aurélien Hess / Christoph Riese / Fabian Gentinetta</small>",
            description: "Attackers know the complexities of managing account permissions across network, cloud and SaaS apps leave gaps for them to abuse. Privileged accounts are routinely used to steal sensitive information and disrupt operations, without ever needing to run an exploit. Some SOC teams focus on monitoring failed login attempts and unusual user behavior, and lean on multi-factor authentication (MFA) to reduce risk. The truth is, those security measures are just one part of the ATO protection equation. You need a proven way to see and stop account takeover attacks in real time.",
            index: 2,
          },
          {
            time: "",
            title: "Searching or finding? In front of or behind your line(s) of defense?<br><small>Kaspersky - Detlev Narr</small>",
            description: "You probably already have the tools! What rules to write? What data to correlate? How to stay up to date? The presentor answers these questions and more, and showcases how you can use Threat Intelligence to improve your organization's security.",
            index: 3,
          },
          {
            time: "",
            title: "Human Risk Management based on AI<br><small>KnowBe4 - Paul Nkengue </small>",
            description: "This presentation focuses on what is probably the most unpredictable part of the IT security equation: people. From phishing attacks and poor password practices to careless handling of sensitive data, learn how to tackle these issues efficiently and effectively.",
            index: 4,
          },
          {
            time: "",
            title: "Goodbye Purple Team, Hello Purple Bots<br><small>Swiss Post Cybersecurity - Patrick Mkhael & Ralph El-Khoury</small>",
            description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
            index: 5,
          },
          {
            time: "",
            title: "Tenable One: Holistic Exposure Management<br><small>Tenable - Thomas Cueni</small>",
            description: "Threat actors do not adhere to silos in the security field. They look for vulnerabilities of all kinds to exploit and move laterally through the environment. But the tools organizations rely on to secure their attack surface often focus only on individual technologies - cloud, identities, IT, OT, IoT, applications - and generate an enormous amount of unnecessary data. What's missing is a cross-functional view of the relationships between assets, identities and risks that enable attacks, and more importantly, the impact on the organization, whether in terms of revenue, data sovereignty, compliance or other critical metrics.<br>The Tenable One exposure management platform unifies visibility, insights and actions across the entire attack surface. ",
            index: 6,
          },
          {
            time: "",
            title: "Capabilities of Modern Security Platforms<br><small>Splunk - Jürg Fischer / Eric De Bressing</small>",
            description: "The right tool for the right job: old and new critical capabilities for SecOps & Enterprise Resilience",
            index: 7,
          },
          {
            time: "",
            title: "Beyond Compliance: Building Resilient & Secure Third-Party Ecosystems<br><small>C2SEC - Renato Martignoni</small>",
            description: "Increasing third-party cyberattacks highlight why vendor risk must go beyond compliance and become part of everyday security operations. This session explores how organizations can leverage evolving regulations like DORA to move beyond one-time compliance toward building continuously secure third-party ecosystems.",
            index: 8,
          },
          {
            time: "",
            title: "A Modern Approach to Telemetry Data Management<br><small>Cribl - Sven Eichfuss / Christoph Dittmann</small>",
            description: "The tidal wave of data is rising, asking for a modern approach to managing and utilizing telemetry data. Cribl will highlight the value of providing teams with ownership over their data while ensuring overall governance and security.",
            index: 9,
          },
          {
            time: "",
            title: "Shadows in the Cloud: Unmasking Advanced Evasion Techniques <br><small>Menlo - Tom McVey / Brett Raybould</small>",
            description: "This session exposes the mechanics behind today's most sophisticated cloud-based attacks. Through live demonstrations of credential phishing and HTML smuggling techniques, Menlo Security's experts will dissect how threat actors bypass traditional security controls. Participants will witness firsthand how these attacks unfold and learn the architectural approaches needed to defend against browser based threats",
            index: 10,
          },
          {
            time: "",
            title: "Threat modeling and it's importance<br><small>Post  - Heinz Wittig </small>",
            description: "In the past two years, the Swiss Post team has embarked on the complex journey of implementing Threat Modeling, akin to the journeys of the companions through Middle-earth. Along the way, they faced challenges reminiscent of the trials of Moria and the watchful eye of Sauron, as well as threats and resistance. Through perseverance and collaboration, they overcame these obstacles and learned more about potential security risks and their early identification. Join them on their adventure and discover the key lessons and strategies that have led them to success in the ever-evolving world of cybersecurity",
            index: 11,
          },
          {
            time: "",
            title: "One Identity Fabric - foundation for modern identity management<br><small>OneIdentity - Reto Bachman / Eric Parietti</small>",
            description: "Presentation of an ecosystem that enables organizations to implement authentication and authorization for all identities (including general users, privileged accounts and third parties) across the entire infrastructure.",
            index: 12,
          },
          {
            time: "",
            title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
            description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
            index: 13,
          },
          {
            time: "",
            title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Raphael Ruf</small>",
            description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
            index: 14,
          },
          {
            time: "",
            title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Antony Ancelin</small>",
            description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
            index: 15,
          },
          {
            time: "17:00",
            title: "",
            description: "<h1>Apero and Networking</h1>",
            index: 16,
          }
        ]}
      />
        }
      </section>
      */}
      {<section>
        {
        <SpeakerSection
          title=""
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Bob",
              lastName: "Lord",
              role: "Former CISO of Yahoo and Founder of Hacklore.org",
              title: 
                "Hacklore and Secure by Design: How Stories Affect Our Safety",
              description:
                "Cybersecurity has a story problem. Juice jacking warnings. QR code panic. Public Wi-Fi paranoia. These urban legends spread through headlines and corporate training decks because the stories are compelling — and compelling stories shape not just what people believe, but who they believe is responsible for staying safe. The Hacklore project examines how false, exaggerated, and outdated security guidance spreads, why it endures, and what it costs us when we place the burden of security on individual behavior instead of the systems that produce harm. But stories don't just spread bad advice — they assign blame. If we want software that is Secure by Design, with security baked in rather than bolted on, we need to start telling stories that point in a different direction: toward the builders, not the users. Hacklore and Secure by Design are two sides of the same story. It's time we changed the ending.",
              image:
              speaker_bob_lord,
            },
            {
              firstName: "Sander",
              lastName: "Hofman",
              role: "Solution Engineer, HarfangLab",
              title: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools?",
              description:
                "",
              image:
                speaker_sander_hofman,
            },
            {
              firstName: "Thomas",
              lastName: "Cueni",
              role: "Tenable",
              title: 
                "Securing the AI You Use—and Using AI to Secure Your Business",
              description:
                "Everyone is feeling the pressure to adopt AI, but how do you keep it from becoming a massive security hole? It's time to move past \"best practice\" documents and look at what it actually takes to lock down AI tools in the real world. But there's a flip side: AI is also your secret weapon. By using agentic AI to transform your exposure intelligence into coordinated action, you can stop just scanning for holes and start proactively managing your entire attack surface to reduce cyber risk.",
              image:
              speaker_thomas_cueni,
            },
            {
              firstName: "Emmanuel",
              lastName: "Schmid",
              role: "Senior Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Every public OT breach is a free lesson: Are you taking notes?",
              description:
                "Operational Technology (OT) security is often framed around ultra-sophisticated adversaries. However, analysis of recent public incidents reveals a recurring reality: a lack of basic security controls. When visibility is limited, we are giving attackers what they need most: time. This session breaks down public OT breaches into actionable threat intelligence by asking a simple questions : what would have caught this, and at what stage? The answers are unglamorous: visibility gaps to close and detection opportunities you can act on today. Public incidents are a gold mine. If we don’t leverage them, we miss a key opportunity to sharpen and adapt OT cybersecurity monitoring strategies.",
              image:
              speaker_emmanuel_schmid,
            },
            {
              firstName: "Antony",
              lastName: "Ancelin",
              role: "Technical lead incident response, Swiss Post Cybersecurity",
              title: 
                "From Detection to Crisis Management: A Real SOC & CSIRT Story",
              description:
                "SPCS will present a real incident that occurred a few weeks ago to demonstrate the practical value of a SOC and a CSIRT. The presentation will cover the full timeline, from the initial SOC detection to the CSIRT investigation and the infrastructure recovery. Beyond the technical investigation, the incident required around-the-clock response, coordination between multiple teams, and crisis management support. This case illustrates that when security tools such as AV or EDR are bypassed, detection, response, coordination, and crisis management become critical to successfully handle the incident.",
              image:
              speaker_antony_ancelin,
            },
            {
              firstName: "Sven",
              lastName: "Kirchmayer",
              role: "Senior Solution Architect, Elastic",
              title: 
                "What Happens When the Attacker's AI Works Harder Than Your Entire SOC?",
              description:
                "In late 2025, Anthropic reported what it described as the first publicly documented AI-orchestrated cyber espionage campaign — a signal that offensive AI is moving from experimentation to operational scale. At the same time, most security teams remain understaffed, overloaded with alerts, and constrained by fragmented tooling built for human-speed response. This session examines what changes when attackers can use AI to accelerate reconnaissance, decision-making, and execution faster than defenders can hire or manually investigate. We’ll look at emerging attack patterns, why platform consolidation matters more than ever, and how security teams can use AI to improve detection, investigation, and response. We’ll also discuss how Elastic helps defenders unify telemetry, reduce tool sprawl, and apply AI in ways that make SOC teams faster, more consistent, and more resilient.",
              image:
              speaker_unknown,
            }
            /*
            {
              firstName: "Gilles",
              lastName: "Peter",
              title: "Territory Manager Suisse",
              description:
                "",
              image:
                speaker_unknown,
            }
            */
          ]}
        />
        }
      </section>}
      {
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [harfanglab_logo],
          [elastic_logo, tenable_logo, vectra_logo],
          [airlock_logo, ywh_logo]
        ]}
      />
      }
      <section>
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
        />
      </section>
      {       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://maps.app.goo.gl/paA3bzXpQ6merQFH8"
          title="Limmat'Hack"
          registerUrl="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594592"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
  specsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
};
